import Field from "@mirage/components/regularField/Field";
import { Grid } from "@mui/material";
import React from "react";
import { IBuildingRegulationsDetails } from "@shared/publicportal/contracts/IBuildingRegulationsDetails";

interface BrSummaryTabContentTabContentProps {
    bcApp: IBuildingRegulationsDetails | null;
    loading: boolean;
}

const BrSummaryTabContent: React.FC<BrSummaryTabContentTabContentProps> = ({ loading, bcApp }) => {
    return (
        <Grid container spacing={2}>
            <Grid item xs={12} md={6} lg={6} xl={6}>
                <Grid item>
                    <Field label="Reference" mode="view" value={bcApp?.name} isLoading={loading} contentType="TEXT" />
                </Grid>
                <Grid item>
                    <Field label="Application Type" mode="view" value={bcApp?.appType?.name} isLoading={loading} contentType="TEXT" />
                </Grid>
                <Grid item>
                    <Field label="Final Proposal" mode="view" value={bcApp?.proposal} isLoading={loading} contentType="TEXT" />
                </Grid>
                <Grid item>
                    <Field label="Location" mode="view" value={bcApp?.location} isLoading={loading} contentType="TEXT" />
                </Grid>
                <Grid item>
                    <Field label="Validation Date" mode="view" value={bcApp?.validationDate} isLoading={loading} contentType="DATE" />
                </Grid>
                <Grid item>
                    <Field label="Deadline Date" mode="view" value={bcApp?.deadlineDate} isLoading={loading} contentType="DATE" />
                </Grid>
                <Grid item>
                    <Field label="Decision" mode="view" value={bcApp?.decision} isLoading={loading} contentType="TEXT" />
                </Grid>
                <Grid item>
                    <Field label="Decision Date" mode="view" value={bcApp?.decisionDate} isLoading={loading} contentType="DATE" />
                </Grid>
                <Grid item>
                    <Field label="Status" mode="view" value={bcApp?.applicationStatus} isLoading={loading} contentType="TEXT" />
                </Grid>
                <Grid item>
                    <Field label="Ward" mode="view" value={bcApp?.ward} isLoading={loading} contentType="TEXT" />
                </Grid>
                <Grid item>
                    <Field label="Parish" mode="view" value={bcApp?.parish} isLoading={loading} contentType="TEXT" />
                </Grid>
                {bcApp?.appType?.name === "Initial Notice" ? (
                    <Grid item>
                        <Field label="Agent Name" mode="view" value={bcApp?.agentCompany} isLoading={loading} contentType="TEXT" />
                    </Grid>
                ) : null}
            </Grid>
            <Grid item xs={12} md={6} lg={6} xl={6}>
                <Grid item>
                    <Field label="Commenced Date" mode="view" value={bcApp?.startedDate} isLoading={loading} contentType="DATE" />
                </Grid>
                <Grid item>
                    <Field label="Completed Date" mode="view" value={bcApp?.completedDate} isLoading={loading} contentType="DATE" />
                </Grid>
            </Grid>
        </Grid>
    );
};

export default BrSummaryTabContent;
